import { moveElementTo } from "../components/move-element";

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header");

  fixHeader();
  moveHeaderNav();

  window.addEventListener("resize", () => {
    moveHeaderNav();
  });

  window.addEventListener("scroll", () => {
    fixHeader();
  });

  function fixHeader() {
    if (window.scrollY > 0) {
      header.classList.add("header--fixed");
    } else {
      header.classList.remove("header--fixed");
    }
  }

  function moveHeaderNav() {
    const elSelector = ".header-nav";

    if (window.innerWidth <= 1024) {
      // Sidebar
      moveElementTo(elSelector, ".header-menu__wrapper", "afterbegin");
    } else {
      // Header
      moveElementTo(elSelector, ".header-nav-outer", "afterbegin");
    }
  }
});

// const headerCollabWrap = document.querySelector(".header-collab__wrap");
// const headerCollabSearch = document.querySelector(".header-collab__search");
// document.addEventListener("click", (e) => {
//   if (
//     e.target.classList.contains("header-collab__button--search") ||
//     e.target.classList.contains("header-search-button")
//   ) {
//     headerCollabWrap.classList.add("d-none");
//     headerCollabSearch.classList.add("header-collab__search--visible");
//   }

//   if (e.target.classList.contains("header-collab__search-close")) {
//     headerCollabWrap.classList.remove("d-none");
//     headerCollabSearch.classList.remove("header-collab__search--visible");
//   }
// });
